import * as Migration from 'shared/migration/migration';


const conversions = [
  { version: '1', rules: [{ isSuitable: () => true, migrateUp: v0tov1 }]},
];

export const CURRENT_VERSION = '1';

export function migrateToTheLatest(actions) {
  return Migration.migrateToTheLatest(actions, conversions);
}

function v0tov1(action) {
  action.schedule ??= {};
  action.schedule.notify ??= {};
  
  const { notify } = action.schedule;
  notify.enableEventsLog ??= true;
  notify.slack ??= {
    channel: '',
    onError: true,
    onSuccess: false,
  };
}